import createModel from 'utils/model'
import {getOrderList, getOrderDetails, unBind} from 'app-self-support-order/services/order-manage'
import {getShopList} from 'app-self-support-order/services/shop-manage'
import _ from 'lodash'
import constants from 'common/constants'

export default createModel({
    namespace: 'selfSupportOrder_orderManage',

    state: {
        tableData: {},
        orderDetailsGoodsList: [], // 订单详情中的商品列表
        shops: [],
    },

    effects: {
        // 获取订单列表
        *getTableData(xx, {select, put, call}) {
            const {tableData} = yield select(
                ({selfSupportOrder_orderManage}) => selfSupportOrder_orderManage,
            )

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }
            if (newParams.time) {
                newParams.start_time = newParams.time[0]
                    ? `${newParams.time[0].format(constants.dateFormat)} 00:00:00`
                    : ''
                newParams.end_time = newParams.time[1]
                    ? `${newParams.time[1].format(constants.dateFormat)} 23:59:59`
                    : ''
            }
            delete newParams.time

            const res = yield call(getOrderList, {...newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        // 订单详情
        *getOrderDetails({payload}, {put, call}) {
            const res = yield call(getOrderDetails, payload)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.orderDetailsGoodsList = res.data
                },
            })
        },

        // 获取店铺列表
        *getShopList(xxx, {put, call}) {
            const res = yield call(getShopList, {offset: 0, limit: 10000})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.shops = res.data
                },
            })
        },

        // 解除绑定
        *unBind({payload}, {call}) {
            return yield call(unBind, payload)
        },
    },
})
